import classNames from 'classnames';
import { FooterAccordion } from './FooterAccordion';
import { FooterHeader } from './FooterHeader';

import '../styles/FooterBlock.scss';

export function FooterBlock({
    customClass,
    title,
    children
}) {
    return (
        <div className={classNames('react-footer-block', customClass)}>
            <div className="react-footer-block__desktop">
                <FooterHeader
                    title={title}
                />
                {children}
            </div>
            <div className="react-footer-block__mobile">
                <FooterAccordion
                    title={title}
                >
                    {children}
                </FooterAccordion>
            </div>
        </div>
    );
}
